"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBrowserApolloClient;
var _client = require("@apollo/client");
var _batchHttp = require("@apollo/client/link/batch-http");
var _persistedQueries = require("@apollo/client/link/persisted-queries");
var _crypto = require("crypto");
var _excluded = ["headers"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var apqLink = (0, _persistedQueries.createPersistedQueryLink)({
  sha256: function sha256(input) {
    return (0, _crypto.createHash)('sha256').update(input).digest('hex');
  },
  useGETForHashedQueries: true
});
var DEFAULT_TARGET_PATH = 'default';
var DEFAULT_LINK_OPTIONS = {
  credentials: 'include',
  batchInterval: 30
};
function createBrowserApolloClient(_ref) {
  var possibleTypes = _ref.possibleTypes,
    metadata = _ref.metadata,
    pageRequestId = _ref.pageRequestId,
    _ref$cacheHydration = _ref.cacheHydration,
    cacheHydration = _ref$cacheHydration === void 0 ? {} : _ref$cacheHydration,
    _ref$uri = _ref.uri,
    uri = _ref$uri === void 0 ? '/graphql' : _ref$uri,
    _ref$linkOptions = _ref.linkOptions,
    linkOptions = _ref$linkOptions === void 0 ? {} : _ref$linkOptions,
    apqEnabled = _ref.apqEnabled,
    _ref$batchingEnabled = _ref.batchingEnabled,
    batchingEnabled = _ref$batchingEnabled === void 0 ? true : _ref$batchingEnabled,
    _ref$devToolsEnabled = _ref.devToolsEnabled,
    devToolsEnabled = _ref$devToolsEnabled === void 0 ? true : _ref$devToolsEnabled,
    _ref$availableLoggedO = _ref.availableLoggedOutPaths,
    availableLoggedOutPaths = _ref$availableLoggedO === void 0 ? [] : _ref$availableLoggedO,
    authLink = _ref.authLink,
    customLinks = _ref.customLinks,
    _ref$typePolicies = _ref.typePolicies,
    typePolicies = _ref$typePolicies === void 0 ? {} : _ref$typePolicies;
  var ApolloHttpLink = batchingEnabled && !apqEnabled ? _batchHttp.BatchHttpLink : _client.HttpLink;
  var appName = metadata.appName,
    appVersion = metadata.appVersion;
  var cache = new _client.InMemoryCache({
    possibleTypes: possibleTypes,
    typePolicies: _objectSpread({}, typePolicies)
  }).restore(cacheHydration);
  var _linkOptions$headers = linkOptions.headers,
    headers = _linkOptions$headers === void 0 ? {} : _linkOptions$headers,
    otherLinkOptions = _objectWithoutProperties(linkOptions, _excluded);
  if (pageRequestId) {
    headers['sm-page-request-id'] = pageRequestId;
  }
  var apolloLinkMemoizeCache = {};
  function apolloLinkFactory() {
    var targetPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_TARGET_PATH;
    if (apolloLinkMemoizeCache[targetPath]) {
      return apolloLinkMemoizeCache[targetPath];
    }
    var link = new ApolloHttpLink(_objectSpread(_objectSpread(_objectSpread({}, DEFAULT_LINK_OPTIONS), otherLinkOptions), {}, {
      uri: targetPath,
      headers: headers
    }));
    if (authLink && targetPath === '/graphql') {
      link = authLink.concat(link);
    }
    if (apqEnabled) {
      link = apqLink.concat(link);
    }
    apolloLinkMemoizeCache[targetPath] = link;
    return link;
  }

  // custom apollo-link that determines the actual link to use based on the passed
  // `targetPath` context.
  var apolloLink = (0, _client.from)([].concat(_toConsumableArray(customLinks || []), [new _client.ApolloLink(function (operation) {
    var _operation$getContext;
    // if the targetPath is not the default, use an alternate graphql endpoint.
    var targetPath = operation === null || operation === void 0 || (_operation$getContext = operation.getContext) === null || _operation$getContext === void 0 || (_operation$getContext = _operation$getContext.call(operation)) === null || _operation$getContext === void 0 ? void 0 : _operation$getContext.targetPath;
    var graphQLPath = uri;
    if (availableLoggedOutPaths.includes(targetPath)) {
      // whitelist for security
      graphQLPath = targetPath;
    }
    return apolloLinkFactory(graphQLPath).request(operation) || _client.Observable.of();
  })]));
  return new _client.ApolloClient({
    connectToDevTools: devToolsEnabled,
    cache: cache,
    link: apolloLink,
    name: appName,
    version: appVersion
  });
}
module.exports = exports.default;
//# sourceMappingURL=browser.js.map